module.exports = __webpack_public_path__ + "img/brm7.93bd466a.jpg";